module.exports = __webpack_public_path__ + "static/WB1-afbfe5f9b2ffbc8ca8c95b963f8c6b92.jpg";